import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import cacheManager from '../CacheManager';
import { showSuccess, showError } from '../utils/toast';

const PgItemEditar = () => {
    const [titulo, setTitulo] = useState('');
    const [duracao, setDuracao] = useState('');
    const [preco, setPreco] = useState('');
    const [descricao, setDescricao] = useState('');
    const [posicao, setPosicao] = useState('');
    const [cor, setCor] = useState('');
    const [linkPagamento, setLinkPagamento] = useState('');
    const [isLoading, setIsLoading] = useState(false); // Estado para controlar o carregamento
    const { id } = useParams(); // Extrai o ID do item da URL
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            setIsLoading(true); // Inicia o carregamento
            fetch(`https://api.faeworks.com.br/item/read.php?id=${id}`)
                .then(response => response.json())
                .then(data => {
                    if (data && data.length > 0) {
                        const item = data[0];
                        setTitulo(item.titulo);
                        setDuracao(item.duracao);
                        setPreco(formatToComma(item.preco));
                        setDescricao(item.descricao);
                        setPosicao(item.posicao);
                        setCor(item.cor);
                        setLinkPagamento(item.link_pagamento);
                    }
                })
                .catch(error => console.error('Erro ao buscar dados do item:', error))
                .finally(() => setIsLoading(false)); // Finaliza o carregamento
        }
    }, [id]); // Dependência: id

    const atualizarItem = async () => {
        try {
            setIsLoading(true);
            const url = id ? 'https://api.faeworks.com.br/item/update.php' : 'https://api.faeworks.com.br/item/create.php';
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id_item: id,
                    titulo: titulo,
                    duracao: duracao,
                    preco: formatToDot(preco),
                    descricao: descricao,
                    posicao: posicao,
                    cor: cor,
                    link_pagamento: linkPagamento,
                }),
            });
            const result = await response.json();
            if (result.status === 'success') {
                setIsLoading(false);
                showSuccess('Item atualizado com sucesso!');
                cacheManager.invalidateItensCache();
                handleVoltarClick();
            } else {
                setIsLoading(false);
                showError('Erro ao atualizar o item: ' + result.message);
                console.error('Erro ao atualizar o item: ' + result.message);
            }
        } catch (error) {
            setIsLoading(false);
            showError('Erro ao atualizar/criar o item: ' + error);
            console.error('Erro ao atualizar/criar o item:', error);
        }
    };

    // Estilos para esmaecer a página
    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 2, // Garanta que esteja acima de outros elementos da página
        display: isLoading ? 'block' : 'none', // Mostra apenas quando está carregando
    };

    const handleTituloChange = (event) => {
        setTitulo(event.target.value);
    };
    
    const handleDuracaoChange = (event) => {
        setDuracao(event.target.value);
    };
    
    const handlePrecoChange = (e) => {
        let value = e.target.value.replace(/[^0-9]/g, ''); // Remove todos os caracteres que não sejam números
        value = value.padStart(3, '0'); // Adiciona zeros à esquerda para garantir pelo menos 3 caracteres
        const integerPart = parseInt(value.slice(0, -2), 10); // Converte a parte inteira para um número
        value = integerPart + ',' + value.slice(-2); // Adiciona a vírgula para o formato 0,00
        setPreco(value);
    };
    
    const handleDescricaoChange = (event) => {
        setDescricao(event.target.value);
    };
    
    const handlePosicaoChange = (event) => {
        setPosicao(event.target.value);
    };
    
    const handleCorChange = (event) => {
        setCor(event.target.value);
    };

    const handleLinkPagamentoChange = (event) => {
        setLinkPagamento(event.target.value);
    };
    
    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevenir o comportamento padrão do formulário
        await atualizarItem(); // Assumindo que atualizarItem agora manipula a lógica de atualização e redirecionamento
    };

    const handleVoltarClick = () => {
        navigate('/itens');
    };

    const formatToComma = (value) => {
        return value.replace('.', ',');
    };

    const formatToDot = (value) => {
        return value.replace(',', '.');
    };


    return (
        <div className="container mt-5">
            {isLoading && <div style={overlayStyle}></div>} {/* Overlay de carregamento */}
            <h1 className="h1">{id ? 'Editar Item' : 'Novo Item'}</h1>
            <form onSubmit={handleSubmit} className="needs-validation" noValidate>
                <div className="row">
                    <div className="col-12 mb-3">
                        <label className="form-label" style={{ display: 'block' }}>
                            Título:
                            <input type="text" className="form-control" value={titulo} onChange={handleTituloChange} />
                        </label>
                    </div>
                    <div className="col-6 mb-3">
                        <label className="form-label" style={{ display: 'block' }}>
                            Duração (minutos):
                            <input type="number" className="form-control" value={duracao} onChange={handleDuracaoChange} />
                        </label>
                    </div>
                    <div className="col-6 mb-3">
                        <label className="form-label" style={{ display: 'block' }}>
                            Preço:
                            <input
                                type="text"
                                className="form-control"
                                value={preco}
                                onChange={handlePrecoChange}
                                placeholder="00,00"
                            />
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 mb-3">
                        <label className="form-label" style={{ display: 'block' }}>
                            Descrição:
                            <textarea className="form-control" value={descricao} onChange={handleDescricaoChange}></textarea>
                        </label>
                    </div>
                    <div className="col-6 mb-3">
                        <label className="form-label" style={{ display: 'block' }}>
                            Posição:
                            <input type="number" className="form-control" value={posicao} onChange={handlePosicaoChange} />
                        </label>
                    </div>
                    <div className="col-6 mb-3" style={{ display: 'none' }}>
                        <label className="form-label" style={{ display: 'block' }}>
                            Cor:
                            <input type="text" className="form-control" value={cor} onChange={handleCorChange} />

                        </label>
                    </div>
                </div>
                <div className="row">
                <   div className="col-12 mb-12" style={{ display: 'block' }}>
                        <label className="form-label" style={{ display: 'block' }}>
                            Link de pagamento:
                            <input type="text" className="form-control" value={linkPagamento} onChange={handleLinkPagamentoChange} />
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 d-flex justify-content-end">
                        <button type="button" className="btn btn-secondary me-2" onClick={handleVoltarClick}>Voltar</button>
                        <button type="submit" className="btn btn-primary">Salvar</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default PgItemEditar;